<template>
  <div class="product-container-right" ref="product-container-right" v-loading="loading">
    <div class="header" v-if="count > 0">
      <span>{{ name }}</span>
      <span>共 {{count}} 件</span>
    </div>
    <vuedraggable class="content" ref="move-box" v-bind="subDragOptions('move-box')" filter=".forbid" :list="list"  handle=".task-drag-box" @add="end" @update="end" :move="onMove">
      <div class="cell" v-for="temp in list" :key="temp.id" @click="editForId(temp.id)" :data-id="temp.id">
        <div class="img-box">
          <div class="img-1">
            <el-image  v-if="temp.images && temp.images[0] && temp.images[0].oss_attachment_name" :src="`${imgBaseUrl}${temp.images[0].oss_attachment_name}?x-oss-process=image/resize,w_540,h_360,limit_0`" fit="contain"></el-image>
            <div v-else>
              <img src="image/product/bg_product@2x.png" alt="">
              <toolTip style="width: 80%;" maxWidth="auto" class="name" :title="temp.product_name">
                <span>{{ temp.product_name }}</span>
              </toolTip>
            </div>
          </div>

          <div class="img-2">
            <el-image  v-if="temp.images && temp.images[1] && temp.images[1].oss_attachment_name" :src="`${imgBaseUrl}${temp.images[1].oss_attachment_name}?x-oss-process=image/resize,w_540,h_360,limit_0`" fit="contain"></el-image>
            <el-image  v-else-if="temp.images && temp.images[0] && temp.images[0].oss_attachment_name" :src="`${imgBaseUrl}${temp.images[0].oss_attachment_name}?x-oss-process=image/resize,w_540,h_360,limit_0`" fit="contain"></el-image>
            <div v-else>
              <img src="image/product/bg_product@2x.png" alt="">
              <toolTip style="width: 80%;" maxWidth="auto" class="name" :title="temp.product_name">
                <span>{{ temp.product_name }}</span>
              </toolTip>
            </div>
          </div>
          <span class="title">{{temp.highlights}}</span>
        </div>
        <div class="bottom-box">
          <toolTip style="width: 70%;" :title="temp.product_name">
            <span>{{ temp.product_name }}</span>
          </toolTip>
          <img v-if="temp.development_status === 10" class="pixelated" src="image/product/img_4@2x.png" alt="">
          <span v-else :class="tag(temp.development_status).class"></span>
        </div>
        <i class="icon iconfont iconicon_drag_order task-drag-box" v-permission="'产品项管理-更新产品项'"></i>
      </div>
    </vuedraggable>
    <nothing v-if="!loading && count === 0"></nothing>
  </div>
</template>
<script>
import api from '@/services/api/product/product'
import { mapState } from 'vuex'
import vuedraggable from 'vuedraggable'
import baseUrl from '@/services/baseUrl'
export default {
  components: { vuedraggable },
  props: {
    params: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    params: {
      handler() {
        this.init()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState('product/product', {
      filterList: state => state.filterList
    }),
    count() {
      let count = this.list.length
      return count
    },
    tag() {
      return (val) => this.filterList.find(res => res.value === val) || {}
    }
  },
  data() {
    return {
      loading: false,
      list: [],
      name: '',
      imgBaseUrl: baseUrl.imgBaseUrl
    }
  },
  created() {

  },
  methods: {
    async init() {
      this.loading = true
      let params = JSON.parse(JSON.stringify(this.params))
      params.development_status = params.development_status !== 0 ? [params.development_status] : params.development_status
      let result = await api.productsIndex({ ...params, page: 1, per_page: 999 })
      result.data.map(res => {
        //遍历对象的属性
        let arr = []
        for(let key in res.images) {
          arr.push(res.images[key])
        }
        res.images = JSON.parse(JSON.stringify(arr.sort((a, b) => a.sort - b.sort)))
      })
      this.list = result.data || []
      console.log('----------', this.list)
      this.name = result.data?.[0]?.product_series?.series_name
      this.loading = false
      this.$nextTick(() => {
        this.$refs['product-container-right'].scrollTop = 0
      })
    },
    groupToArrayByValue(arrData) {
      let result = {
        level10: [],
        level20: [],
        level30: [],
        level40: [],
      }
      arrData.forEach((item) => {
        result["level" + item.development_status] ? result["level" + item.development_status].push(item) : (result["level" + item.development_status] = [item])
      })
      return result
    },
    getStatus(val) {
      return this.filterList.find(res => res.value === val)?.img
    },
    editForId(id) {
      this.$router.push(`/productDataIndex?id=${id}`)
    },
    subDragOptions(key) {
      return {
        animation: 200,
        group: key,
      }
    },
    async end(event) {
      let id = event.item.dataset.id * 1;
      let index = this.list.findIndex(res => res.id == id)
      let previous_id = index - 1 < 0 ? 0 : this.list[index - 1].id
      let next_id = (index + 1) > (this.list.length - 1) ? 0 : this.list[index + 1].id

      let nextItem = this.list.find(res => res.id == next_id)
      let previousItem = this.list.find(res => res.id == previous_id)
      let currentItem = this.list.find(res => res.id == id)
      if (!nextItem || nextItem.development_status !== currentItem.development_status) {
        next_id = 0
      }
      if (!previousItem || previousItem.development_status !== currentItem.development_status) {
        previous_id = 0
      }

      let params = {
        id,
        previous_id,
        next_id
      }
      console.log(index, this.list, params)
      await api.productsUpdateSort(params)
      this.$message({
        message: '修改成功',
        type: 'success',
      })
    },
    onMove(e) {
      return e.draggedContext.element.development_status === e.relatedContext.element.development_status
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin";
.product-container-right {
  position: relative;
  flex: 1;
  overflow-x: hidden;
  .header {
    position: sticky;
    top: 0;
    right: 0;
    left: 0;
    display: flex;
    padding-left: 49px;
    align-items: center;
    justify-content: space-between;
    padding-top: 6px;
    padding-bottom: 16px;
    z-index: 100;
    background-color: #F5F5F5;
    padding-right: 20px;
    span:first-child {
      font-size: 18px;
      font-weight: 500;
      margin-right: 16px;
    }
    span:last-child {
      font-size: 14px;
      color: rgba(32, 32, 32, 0.60);
    }
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    padding-top: 20px;
    padding-left: 49px;
    padding-right: 20px;
    gap: 24px;
  }
  .cell {
    width: 360px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    &:hover {
      box-shadow: 0px 8px 32px 0px rgba(0,0,0,0.16);
      .img-box {
        transition: all .3s;
        .title, &::after {
          visibility: visible;
        }
        .img-1 {
          opacity: 0;
        }
        .img-2 {
          opacity: 1;
        }
      }
      .task-drag-box {
        visibility: visible;
      }
    }
    .task-drag-box {
      position: absolute;
      color: #5E666D;
      font-size: 14px;
      top: 16px;
      left: 16px;
      visibility: hidden;
      z-index: 999;
      padding: 4px;
      border-radius: 4px;
      cursor: pointer;
      background-color: rgba(255, 255, 255, 0.6);
      &:hover {
        background-color: rgba(255, 255, 255, 0.7);
      }
      &:active {
        background-color: rgba(255, 255, 255, 0.8);
      }
    }
    .img-box {
      height: 240px;
      width: 100%;
      flex-shrink: 0;
      position: relative;
      .el-image {
        height: 100%;
        overflow: hidden;
        border-radius: 6px 6px 0 0;
      }
      img {
        width: 100%;
        height: 100%;
        border: 0 none !important;
      }
      .title {
        position: absolute;
        left: 16px;
        bottom: 16px;
        right: 16px;
        font-size: 14px;
        color: #fff;
        text-shadow: 0px 3px 8px rgba(0,0,0,0.16);
        @include ellipsis(3);
        visibility: hidden;
        z-index: 1;
      }
      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background-color: rgba(0,0,0,0.16);
        visibility: hidden;
        border-radius: 6px 6px 0 0;
      }
      .img-2 {
        opacity: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        text-align: center;
        transition: all .4s;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        >div {
          width: 100%;
          height: 100%;
        }
      }
      .img-1 {
        opacity: 1;
        width: 100%;
        height: 100%;
        overflow: hidden;
        text-align: center;
        transition: all .4s;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        >div {
          width: 100%;
          height: 100%;
        }
      }
      .name {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-weight: 500;
        font-size: 28px;
        color: #FFFFFF;
        text-align: center;
      }
    }
    .bottom-box {
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      position: relative;
      font-size: 16px;
      font-weight: 500;
      img {
        height: 32px;
        image-rendering: crisp-edges;
        line-height: 1;
        &.pixelated {
          image-rendering: pixelated;
        }
      }
    }
  }
}
</style>
